export const SFZ_API_LINK = process.env.VUE_APP_SFZ_API_LINK || 'https://api-ittara.dafa.dev/v1/'
export const BASE_API_LINK = process.env.VUE_APP_BASE_API_LINK || 'https://api-ittara.dafa.dev/'
